import { ArrowBack } from '@mui/icons-material';
import { Box } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import {
  DriverLogo,
  HeadContainerInner,
  HeadDivider,
  HeaderContainer,
  LeftSection,
  LinearProgressStyled,
  LogoImage,
  RightSection,
} from './styles';

export interface HeaderProps {
  previousPage?: () => void;
  progressValue?: number;
  logoSrc?: string;
  showBackButton?: boolean;
}

const Header = ({ logoSrc, progressValue = 0, previousPage, showBackButton }: HeaderProps) => {
  return (
    <HeaderContainer>
      <HeadContainerInner>
        <LeftSection>
          {showBackButton ? (
            <Box onClick={previousPage} sx={{ cursor: 'pointer', display: 'flex' }}>
              <ArrowBack />
            </Box>
          ) : null}
        </LeftSection>
        <HeadDivider>
          {logoSrc ? (
            <DriverLogo>
              <LogoImage src={logoSrc} alt="All My Sons Moving and Storage" />
            </DriverLogo>
          ) : null}
        </HeadDivider>
        <RightSection />
      </HeadContainerInner>
      <LinearProgressStyled>
        <LinearProgress variant="determinate" value={progressValue} color="primary" />
      </LinearProgressStyled>
    </HeaderContainer>
  );
};

export default Header;
